import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { IDefaultPopupCustomStyles } from '@r1-frontend/ui-react/components/popups/defaultPopup';

export const popupCustomStyles: IDefaultPopupCustomStyles = {
    popup: {
        default: {
            padding: '32px',
            overflowY: 'initial',
        },
        mobile: {
            padding: '24px',
        },
    },
};

const Wrapper = styled.div`
    flex-direction: column;
    width: 100%;
`;

export const PopupContentWrapper = styled(Wrapper)`
    row-gap: 20px;

    h3 {
        width: calc(100% - 36px - 8px);
        white-space: break-spaces;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        row-gap: 16px;

        h3 {
            width: calc(100% - 28px - 8px);
            white-space: break-spaces;
        }
    }
`;

export const PhoneFormWrapper = styled(Wrapper)`
    row-gap: 16px;
`;

export const VerifyTypesWrapper = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    column-gap: 16px;
`;
